







import Vue from 'vue'
export default Vue.extend({
  props: {
    width: {
      default: '100%',
      type: String
    },
    height: {
      default: '1em',
      type: String
    }
  }
})
